import React, { useEffect, useMemo } from 'react';
import { connect, useSelector } from 'react-redux';
import { actions } from '../redux/ProductReducer';
import { Loader } from '../../../common/components';
import InternalContainer from '../../layout/containers/Internal';
import SchemesSummary from '../components/SchemesSummary/SchemesSummary';

import getIncludedResource from '../../../helpers/getIncludedResource';
import { getActiveSchemes, getTestSchemes } from '../helpers/getTestSchemes';
import { bySchemeTypeAndCoverLevel } from '../helpers/formatSchemes';

const ProductSchemesContainer = ({ params, getProduct }) => {
  const { productId } = params;

  const { isLoading, product } = useSelector((state) => state.productManagement);
  const currentProductId = product?.data?.id;

  useEffect(
    () => {
      getProduct(productId, ['all_schemes']);
    },
    [productId, getProduct],
  );

  const refreshPage = () => {
    getProduct(productId, ['all_schemes']);
  };

  const isReady = currentProductId === productId;
  const schemes = isReady
    ? getIncludedResource(product?.data, product?.included, 'all_schemes')
    : [];
  const isSchemesReady = Array.isArray(schemes);

  const formattedSchemes = useMemo(
    () => bySchemeTypeAndCoverLevel(isSchemesReady ? schemes : []),
    [schemes, isSchemesReady],
  );

  const schemesInTest = useMemo(() => getTestSchemes(isSchemesReady ? schemes : []), [
    schemes,
    isSchemesReady,
  ]);
  const activeSchemes = useMemo(() => getActiveSchemes(isSchemesReady ? schemes : []), [
    schemes,
    isSchemesReady,
  ]);

  if (isLoading || !product?.data || currentProductId !== productId) {
    return (
      <InternalContainer title="Scheme management">
        <Loader />
      </InternalContainer>
    );
  }

  const baseUrl = `/admin/products/${productId}/schemes/`;

  return (
    <div className="admin-area">
      <InternalContainer title="Scheme management">
        <SchemesSummary
          show={true}
          productId={productId}
          productName={product.data.attributes.name}
          productCode={product.data.attributes.product_code}
          schemes={formattedSchemes}
          schemesInTest={schemesInTest}
          activeSchemes={activeSchemes}
          title={product.data.attributes.name}
          onRefreshPage={refreshPage}
          baseUrl={baseUrl}
        />
      </InternalContainer>
    </div>
  );
};

export default connect(
  null,
  {
    getProduct: actions.getProduct,
  },
)(ProductSchemesContainer);
